<template>
    <div style="width: 100%;">


      <!-- <template>
  <div>
    <HeaderMain />
  </div>
</template> -->


   <div class="header-main" style="width: 100%;">
    <div class="hm-left ">
      <div>
        <div class="bread-crumb"></div>
        <div class="header-main__title-wrap">
          <h1 class="header-main__title">Задачи</h1>
          <div class="header-main__review"></div>
        </div>
      </div>
    </div>

    <div class="hm-right">
      <div class="btn-wrapper btn-wrapper_group new">
         <button @click="logout" class="btn_ms m0 btn">Выход</button>
        <router-link to="/" class="btn_ms m0 btn" v-if="$store.state.user.id === 14">
          <div class="">Товары</div>
        </router-link>
        <router-link to="/orders" class="btn_ms m0 btn">
          <div class="">Заказы</div>
        </router-link>

        
        
      <router-link to="/tasksto" class="btn_ms m0 btn">
          <div class="">Задачи</div>
        </router-link>   
        <router-link to="/sto" class="btn_ms m0 btn">
          <div class="">Посты</div>
        </router-link>    
        <div class="btn-content btn-content_icon btn-content_new" @click="openNewOrderModal">Новый заказ</div>          
      </div>
    </div>
  </div>
  <div class="calendar-app">
    <!-- Сайдбар: слева – задачи и заказы -->
    <div class="sidebar">
  <!-- Вкладки для переключения -->
  <div class="tabs">
    <button 
      :class="{ active: activeTab === 'tasks' }" 
      @click="activeTab = 'tasks'">
      Задачи
    </button>
    <button 
      :class="{ active: activeTab === 'orders' }" 
      @click="activeTab = 'orders'">
      Заказы
    </button>
  </div>

  <!-- Блок задач -->
  <div v-if="activeTab === 'tasks'">
    <!-- Блок Калькуляции -->
    <div class="calculation-block">
      <!-- Заголовок: "Калькуляция (кол-во)" и общая сумма -->
      <div class="calculation-header">
        <span class="calculation-title-header">
          {{ formatDateToYMDcustom(currentDate) }}
        </span>
      </div>

      <!-- Список карточек задач (именно на выбранный день) -->
      <ul class="calculation-list">
        <li
          class="calculation-item"
          v-for="task in currentDayTasks"
          :key="task.id"
          @click="openEditModal(task)"
        >
          <!-- Верхняя часть карточки (модель авто + госномер и клиент/организация) -->
          <div class="calculation-item-header">
            <div class="calculation-car-model">
              <div class="calculation-date">
                {{ formatDate(task.date) }} {{ formatTime(task.start_hour) }}
              </div>
              <span class="calculation-plate" v-if="task.order && task.order.licensePlate">
                {{ task.order.licensePlate }}
              </span>
            </div>
            <div class="calculation-organization">
              {{ task.user_label ? task.user_label : currentUser.label }}
            </div>
          </div>

          <!-- Основной блок: дата/время, телефон, комментарий -->
          <div class="calculation-item-body">
            <div class="calculation-title">
              {{ task.title }}
            </div>
            <div class="calculation-phone" v-if="task.order && task.order.phone">
              <a :href="'tel:' + task.order.phone">{{ task.order.phone }}</a>
            </div>
            <div
              class="calculation-comment"
              v-if="task && task.text"
              :title="task.text"
            >
            <span class="label_span">Комментарий:</span>
              <div>{{ task.text }}</div>
            </div>


            <span class="label_span" v-if="getOrderField(task, 'number')" style="margin-top: 5px;margin-bottom: 3px;">К задаче прикрплен заказ:</span>
             <div
  class="calculation-block-zakaz"
  v-if="
    getOrderField(task, 'number') ||
    getOrderField(task, 'phone') ||
    getOrderField(task, 'customFields.marka_podbor')
  "
>

  <div class="block_zakaz" v-if="getOrderField(task, 'number')">
    <span class="label_span">Заказ:</span>
    <div>{{ getOrderField(task, 'number') }}</div>
  </div>
  <div class="block_zakaz" v-if="getOrderField(task, 'phone')">
    <span class="label_span">Телефон:</span>
    <div>{{ getOrderField(task, 'phone') }}</div>
  </div>
  <div class="block_zakaz" v-if="getOrderField(task, 'customFields.marka_podbor')">
    <span class="label_span">Машина:</span>
    <div>{{ getOrderField(task, 'customFields.marka_podbor') }}</div>
  </div>
</div>

          </div>


         
          
          

          <!-- Иконка удаления (только если задача моя) -->
          <span
            v-if="task.user_id && task.user_id === currentUser.id"
            class="calculation-delete"
            @click.stop="deleteTask(task)"
            title="Удалить задачу"
          >
            ×
          </span>
        </li>
      </ul>
    </div>
  </div>

  <!-- Блок заказов -->
  <div v-if="activeTab === 'orders'">
    <div class="orders-list">
      <h3>Список заказов</h3>
      <!-- Фильтры -->
      <div class="filter-buttons">
        <button
          :class="{ active: activeStatus === '' }"
          @click="filterByStatus('')"
          style="background:rgb(53 122 189)"
        >
          Все
        </button>
        <button
          v-for="(status, index) in visibleFilterStatuses"
          :key="status.value"
          :class="{ active: activeStatus === status.value }"
          @click="filterByStatus(status.value)"
          :style="{ background: status.color }"
        >
          {{ status.label }}
        </button>
        <button
          v-if="!showAllFilterButtons && filterStatuses.length > 6"
          @click="showAllFilterButtons = true"
        >
          Показать ещё
        </button>
      </div>
      <!-- Поле ввода телефона -->
    <div class="phone-search-container">
  <input
    v-model="phoneFilter"
    placeholder="Поиск по телефону"
    class="phone-search-input"
    @keyup.enter="searchByPhone"
  />
  <button
    v-if="phoneFilter"
    class="clear-icon"
    @click="clearPhoneFilter"
    title="Очистить"
  >
    ✕
  </button>
  <button class="phone-search-button" @click="searchByPhone">Найти</button>
</div>




      
      <!-- Карточки заказов -->
      <div class="orders-grid">
        <div
          class="order-card"
          v-for="order in orders"
          :key="order.id"
          draggable="true"
          @dragstart="onDragStartFromList($event, order)"
        >
         
        <div class="calculation-block-zakaz-sto">
         <div class="edit-order-btn" @click="editOrder(order)" title="Редактировать заказ"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 401.523 401" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M370.59 250.973c-5.524 0-10 4.476-10 10v88.789c-.02 16.562-13.438 29.984-30 30H50c-16.563-.016-29.98-13.438-30-30V89.172c.02-16.559 13.438-29.98 30-30h88.79c5.523 0 10-4.477 10-10 0-5.52-4.477-10-10-10H50c-27.602.031-49.969 22.398-50 50v260.594c.031 27.601 22.398 49.968 50 50h280.59c27.601-.032 49.969-22.399 50-50v-88.793c0-5.524-4.477-10-10-10zm0 0" fill="#c50f0f" opacity="1" data-original="#000000"></path><path d="M376.629 13.441c-17.574-17.574-46.067-17.574-63.64 0L134.581 191.848a9.997 9.997 0 0 0-2.566 4.402l-23.461 84.7a9.997 9.997 0 0 0 12.304 12.308l84.7-23.465a9.997 9.997 0 0 0 4.402-2.566l178.402-178.41c17.547-17.587 17.547-46.055 0-63.641zM156.37 198.348 302.383 52.332l47.09 47.09-146.016 146.016zm-9.406 18.875 37.62 37.625-52.038 14.418zM374.223 74.676 363.617 85.28l-47.094-47.094 10.61-10.605c9.762-9.762 25.59-9.762 35.351 0l11.739 11.734c9.746 9.774 9.746 25.59 0 35.36zm0 0" fill="#c50f0f" opacity="1" data-original="#000000"></path></g></svg></div>
          <div class="block_zakaz" style="border-left:none">
            <span class="label_span">Заказ:</span>
            <div>{{ order.number }}</div>
          </div>
          <div class="block_zakaz">
            <span class="label_span">Телефон:</span>
            <div style="display: flex;align-items: center;"><div v-if="order.phone" @click="makeCall(order.phone)"  class="call-button"></div> {{ order.phone }}</div>
          </div>
          <div class="block_zakaz_all" v-if="order.customerComment">
            <span class="label_span">Комментарий клиента:</span>
            <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
              <span>{{ order.customerComment }}</span>
              <button 
                v-if="hasImage(order.customerComment)"
                :style="{
                  padding: '4px',
                  fontSize: '11px',
                  border: 'none',
                  cursor: 'pointer',
                  color: copiedStates[order.id] ? '#fff' : '#000',
                  background: copiedStates[order.id] ? '#4caf50' : 'orange',
                  transition: 'background-color 0.3s ease'
                }" 
                @click.stop="copyToClipboard(extractImageUrl(order.customerComment), order.id)"
              >
                {{ copiedStates[order.id] ? 'Скопировано ✓' : 'Копировать' }}
              </button>
            </div>
          </div>

           <div class="block_zakaz_all" v-if="order.managerComment">
            <span class="label_span">Комментарий:</span>
            <div>{{ order.managerComment }}</div>
          </div>

          <div class="block_zakaz_all" v-if="order.customFields.neobkhodimye_raboty_sto ">
            <span class="label_span">Требуемые работы:</span>
            <div>{{ order.customFields.neobkhodimye_raboty_sto }}</div>
          </div>

          <div class="block_zakaz_all" v-if="order.customFields.marka_podbor">
            <span class="label_span">Машина:</span>
            <div>{{order.customFields.marka_podbor}} {{order.customFields.model_podborts}} {{order.customFields.nazvats_podbor}} {{order.customFields.toplivo_vid}} </div>

          </div>
           <div class="block_zakaz_all" v-if="order.customFields.planiruemaia_data_vizita">
            <span class="label_span">Планируемая дата посещения:</span>
            <div>{{formatDates(order.customFields.planiruemaia_data_vizita)}}</div>

          </div>



      <div class="block_zakaz_all_select" >
        <span class="label_span">Статус:</span>
        <!-- Кастомный селект для смены статуса -->
        <CustomSelect
          :order="order"
          :statuses="statuses"
          @update:orderStatus="order.status = $event"
        />
        </div>

        
      </div>


          
          
          <!-- Tooltip с дополнительной информацией -->
          <div class="tooltip">
            <div><strong>Марка авто:</strong> {{ order.car || 'Не указано' }}</div>
            <div><strong>Год выпуска:</strong> {{ order.year || 'Не указан' }}</div>
            <div>
              <strong>Что нужно сделать:</strong>
              {{ order.taskDescription || order.customerComment || 'Нет описания' }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


    <!-- Правая часть – календарь -->
    <div class="calendar-container">
      <div class="calendar-header">
        <button
          v-for="mode in ['month', 'week', 'day']"
          :key="mode"
          @click="switchView(mode)"
          :class="['header-btn', { active: viewMode === mode }]"
        >
          {{ mode === 'month' ? 'Месяц' : mode === 'week' ? 'Неделя' : 'День' }}
        </button>
        <button class="nav-btn" @click="goPrev">‹</button>
        <span class="header-current">{{ displayLabel }}</span>
        <button class="nav-btn" @click="goNext">›</button>
      </div>
      <MonthView
        v-if="viewMode === 'month'"
        :currentDate="currentDate"
        :tasks="tasks"
        @dayClick="drillDownToDay"
        @daySelect="selectDay"
        @taskClick="openEditModal"
        @taskDropped="handleTaskDropped"
      />
      <WeekView
        v-else-if="viewMode === 'week'"
        :currentDate="currentDate"
        :tasks="tasks"
        @timeSlotClick="openAddModal"
        @dayHeaderClick="selectDay"
        @taskClick="openEditModal"
        @taskDropped="handleTaskDropped"
      />
      <DayView
        v-else
        :currentDate="currentDate"
        :tasks="tasks"
        @timeSlotClick="openAddModal"
        @taskClick="openEditModal"
        @taskDropped="handleTaskDropped"
      />



<!-- Модальное окно "Новый заказ" -->
<div v-if="modalNewOrderVisible" class="custom-modal__overlay" @click.self="closeNewOrderModal">
  <div class="custom-modal new_order">
    <div class="custom-modal__header">
  {{ editingOrderId ? 'Редактирование заказа - RetailCrm' : 'Новый заказ - RetailCrm' }}
</div>
    <div class="custom-modal__content">
      <div class="custom-modal__info">
        <label>Оформил заказ:</label>
        <div style="font-weight: 800;">{{ currentUser.label }}</div>
      </div>
      <!-- Отображение выбранных услуг (если требуется) -->
      <div v-if="selectedServices.length" style="margin-top: 0px; margin-bottom: 20px;">
        <label>Требуются работы:</label>
        <div style="font-size: 14px; line-height: 14px; font-weight: 600;">
          <span v-for="service in selectedServices" :key="service.id">
            {{ service.name }}; 
          </span>
        </div>
      </div>

      <div v-if="newOrderItems.length" style="margin-top: 15px;">
  <label style="font-weight: 600; font-size: 14px; margin-bottom: 5px; display: inline-block;">
    Список работ и товаров:
  </label>

  <div
    v-for="(item, index) in newOrderItems"
    :key="index"
    class="compact-product-item"
  >
    <input
      v-model="item.name"
      class="compact-input name"
      placeholder="Название"
    />
    <input
      type="number"
      v-model.number="item.quantity"
      class="compact-input small"
      min="0"
      placeholder="Кол-во"
    />
    <input
      type="number"
      v-model.number="item.price"
      class="compact-input small"
      min="0"
      placeholder="Цена"
    />
    <span class="sum">{{ item.quantity * item.price }} BYN</span>
    <button
      @click="removeOrderItem(index)"
      class="btn-remove"
    >
      ✕
    </button>
  </div>
</div>

<button class="custom-modal__btn sto_product" @click="addOrderItem">
  Добавить товар
</button>




       <div class="contact_block">
       <div class="custom-modal__info">
        <label>Имя:</label>
        <input
          type="text"
          v-model="newOrderName"
          class="app-input"
          placeholder="Имя клиента"
        />
      </div>

      <div class="custom-modal__info">
        <label>Телефон:</label>
        <input
          type="text"
          v-model="newOrderPhone"
          class="app-input"
          placeholder="Введите телефон"
        />
      </div>
    </div>
    
    <div class="contact_block">
      
    <div class="custom-modal__info">
        
        <label>Машина:</label>
        <div style="display:flex;align-items: center;">
          <div class="auto_podbor" @click="openCarSelector"></div>
        <input
          type="text"
          v-model="newOrderCar"
          class="app-input"
          placeholder="Введите марку автомобиля"
        />
      </div>
      </div>
    <div class="custom-modal__info">
          <label>Планируемая дата визита:</label>
          <flat-pickr 
            v-model="selectedDatePlan" 
            :config="flatpickrConfig"
            class="app-input"
            :readonly="!!droppedOrder"  
          />
        </div>
      </div>

      <label>Комментарий:</label>
      <textarea
        class="custom-modal__textarea"
        v-model="newOrderComment"
        placeholder="Введите комментарий..."
      ></textarea>
      
      <!-- Кнопка для открытия окна выбора услуг (если необходимо) -->
      <div style="margin-top: 10px;">
        <button class="custom-modal__btn sto" @click="openServiceModal">
           Добавить работы
        </button>

     
      </div>
    </div>
    <div class="custom-modal__footer">
      <button class="custom-modal__btn" @click="saveNewOrder">
        {{ editingOrderId ? 'Обновить' : 'Сохранить' }}
      </button>
      <button class="custom-modal__btn custom-modal__btn--cancel" @click="closeNewOrderModal">Отмена</button>
    </div>
  </div>
</div>













<!-- Модальное окно "Добавить задачу" -->
<div v-if="modalAddVisible" class="custom-modal__overlay" @click.self="closeAddModal">
  <div class="custom-modal">
    <div class="custom-modal__header">Добавить задачу</div>
    <div class="custom-modal__content">
      <div class="custom-modal__info">
        <label>Поставил задачу:</label>
        <div style="font-weight: 800;">{{ currentUser.label }}</div>
      </div>

      <div class="form_date_block">
        <div class="custom-modal__info">
          <label>Заголовок задачи:</label>
          <input
            type="text"
            v-model="newTaskTitle"
            class="app-input"
            placeholder="Введите заголовок задачи"
          />
        </div>
        <div class="custom-modal__info">
          <label>Дата и время выполнения:</label>
          <flat-pickr 
            v-model="selectedDateInput" 
            :config="flatpickrConfig"
            class="app-input"
            :readonly="!!droppedOrder"  
          />
        </div>
      </div>



       <!-- Отображение выбранных услуг -->
      <div v-if="selectedServices.length" style="margin-top: 0px;margin-bottom: 20px;">
        <label>Выбранные работы:</label>
        <div style="    font-size: 14px;line-height: 14px;font-weight: 600;">
          <span v-for="service in selectedServices" :key="service.id">{{ service.name }}; </span>
        </div>
      </div>

      <div class="form_date_block">
      <div class="custom-modal__info">
        <label>Телефон:</label>
        <input
          type="text"
          v-model="newTaskPhone"
          class="app-input"
          placeholder="Введите телефон"
        />
      </div>
      <div class="custom-modal__info">
        <label>Машина:</label>
        <input
          type="text"
          v-model="newTaskCar"
          class="app-input"
          placeholder="Введите марку автомобиля"
        />
      </div>
    </div>

      <label>Комментарий:</label>
      <textarea
        class="custom-modal__textarea"
        v-model="newTaskText"
        placeholder="Введите дополнительные сведения..."
      ></textarea>
      
      <!-- Кнопка для открытия модального окна выбора услуг -->
      <div style="margin-top: 10px;">
        <button class="custom-modal__btn sto" @click="openServiceModal">Добавить работы</button>
      </div>
      
     
      
      <div v-if="droppedOrder" class="custom-modal__info_sto">
        <div><strong>Номер заказа:</strong> {{ droppedOrder.number }}</div>
        <div><strong>Телефон:</strong> {{ droppedOrder.phone }}</div>
        <div><strong>Машина:</strong> {{ droppedOrder.car }}</div>
        <div><strong>Комментарий:</strong> {{ droppedOrder.customerComment }}</div>
        <div><strong>Статус:</strong> {{ droppedOrder.status }}</div>
      </div>
    </div>
    <div class="custom-modal__footer">
      <button class="custom-modal__btn" @click="saveNewTask">Сохранить</button>
      <button class="custom-modal__btn custom-modal__btn--cancel" @click="closeAddModal">Отмена</button>
    </div>
  </div>
</div>

<!-- Дополнительное модальное окно "Выбор работ" -->
<div v-if="serviceModalVisible" class="custom-modal__overlay" @click.self="closeServiceModal">
  <div class="custom-modal sto">
    <div class="custom-modal__header">Выберите работы СТО</div>
    <div class="custom-modal__content">
      <ul>
        <li v-for="service in serviceList" :key="service.id">
          <div style="display: flex; align-items: center;">
            <!-- Иконка для раскрытия/сворачивания -->
            <span 
              @click="toggleService(service.id)" 
              style="cursor: pointer; margin-right: 5px; font-weight: bold; width: 20px; text-align: center;">
              {{ isExpanded(service.id) ? '-' : '+' }}
            </span>
            <label>
              <input type="checkbox" :value="service" v-model="tempSelectedServices" /> {{ service.name }}
            </label>
          </div>
          <!-- Дочерние услуги отображаются, если категория раскрыта -->
          <ul v-if="service.children && service.children.length && isExpanded(service.id)" style="margin-left: 20px;">
            <li v-for="child in service.children" :key="child.id">
              <label>
                <input type="checkbox" :value="child" v-model="tempSelectedServices" /> {{ child.name }}
              </label>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="custom-modal__footer">
      <button class="custom-modal__btn" @click="confirmServices">Готовы</button>
      <button class="custom-modal__btn custom-modal__btn--cancel" @click="closeServiceModal">Отмена</button>
    </div>
  </div>
</div>




      <!-- Модальное окно "Редактировать задачу" -->
      <div
        v-if="modalEditVisible"
        class="custom-modal__overlay"
        @click.self="closeEditModal"
      >
        <div class="custom-modal">
          <div class="custom-modal__header">Редактировать задачу</div>
          <div class="custom-modal__content">
            <div class="custom-modal__info">
              <label>Поставил задачу:</label>
              <div style="font-weight: 800;">
                {{ editingTask && editingTask.user ? editingTask.user.label : currentUser.label }}
              </div>
            </div>


            <div class="form_date_block">
            <div class="custom-modal__info">
              <label>Заголовок задачи:</label>
              <input
                type="text"
                v-model="editTaskTitle"
                class="app-input"
                placeholder="Введите заголовок задачи"
              />
            </div>

             

            <div class="custom-modal__info">
              <label>Дата и время выполнения:</label>
              <flat-pickr 
                v-model="editDateInput" 
                :config="flatpickrConfig"
                class="app-input"
              />
            </div>



          </div>


            
            <label>Комментарий:</label>
            <textarea class="custom-modal__textarea" v-model="editTaskText"></textarea>
          </div>
          <div class="custom-modal__footer">
            <button class="custom-modal__btn" @click="saveEditedTask">
              Сохранить
            </button>
            <button class="custom-modal__btn custom-modal__btn--cancel" @click="closeEditModal">
              Отмена
            </button>
          </div>
        </div>
      </div>




    </div>
  </div>



<div class="modal car-selector" v-if="isCarSelectorVisible">
  <div class="modal-content">
    <button class="close-button" @click="closeCarSelector">X</button>
    <car-selector ref="carSelector" @update-link="updateCorpus"></car-selector>
  </div>
</div>




</div>
</template>

<script>
import { ORDERS_API_BASE } from '@/config/api';
import axios from "axios";
import MonthView from "./MonthView.vue";
import WeekView from "./WeekView.vue";
import DayView from "./DayView.vue";
import CustomSelect from "@/components/CustomSelect.vue"; 
import CarSelector from '@/components/CarSelector.vue';
import HeaderMain from '@/components/HeaderMain.vue';
// Импортируем flatPickr и его стили
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian } from "flatpickr/dist/l10n/ru.js";

export default {
  name: "CalendarApp",
  components: { MonthView, WeekView, DayView, flatPickr, CustomSelect, CarSelector, HeaderMain },
  data() {
    return {
      viewMode: "month",
      currentDate: new Date(),
      tasks: [],
      modalAddVisible: false,
      modalEditVisible: false,
      modalNewOrderVisible: false, // для нового заказа
      activeTab: 'tasks',
      selectedDateInput: new Date(), 
      selectedDatePlan: new Date(), 
      newOrderItems: [],
      newTaskText: "",
      newTaskTitle: "",
      products: [], // Список добавленных товаров
      phoneFilter: '',
      editingTask: null,
      copiedStates: {},
      auto: '',
      isCarSelectorVisible: false,
      editTaskText: "",
      editTaskTitle: "",
      editTaskOrder: "",
      orders: [],
      filterStatuses: [
        { label: 'Новый', value: 'new', color: 'linear-gradient(rgb(254, 165, 48), rgb(228, 142, 30))' },
        { label: 'Авто ожидает ремонта (ждет зч/очередь)', value: 'stoffnksajn12212', color: 'rgb(255, 239, 191)' },
        { label: 'Авто в ремонте, в цеху', value: 'avto-v-remonte-v-tsekhu', color: 'rgb(152, 188, 223)' },
        { label: 'Необходим подбор и продажа запчастей', value: 'sto-prodazaza', color: '#add8e6' },
        { label: 'Ничего не нужно, не поможем (указываем причину)', value: 'stowfifdk2j', color: 'rgb(217 220 255)' },
        { label: '5а. Собственная продажа магазина', value: '5asjkdhgfilu333', color: 'rgb(33, 184, 137)' },
        { label: 'Готово к выдаче авто', value: 'gotov-k-vydache', color: '#90ee90' },
        { label: 'Проконсультирован, пнуть клиента позже', value: 'prokonsultirovan-perezvonit-pozzhe', color: '#d3d3d3' },
        { label: 'Необходимо перезвонить клиенту: запчасти, цены, перечень работ (СТО)', value: 'neobkhodimo-perezvonit-klientu-zapchasti-tseny-perechen-rabot-sto', color: '#ffe4b5' },
        { label: 'Авто выдан клиенту', value: '5-avto-vydan-klientu', color: '#add8e6' },
      ],
      serviceModalVisible: false, // новое: видимость модального окна выбора услуг
    serviceList: [
  {
    id: "remont_podveski",
    name: "Ремонт подвески",
    children: [
      { id: "razval_skhodjdenie", name: "развал схождение" },
      { id: "razval_skhodjdenie_3d", name: "развал схождение 3D" },
      { id: "remont_pnevmopodveski", name: "ремонт пневмоподвески" },
      { id: "remont_zadney_balki", name: "ремонт задней балки" },
      { id: "remont_kardannykh_valov", name: "ремонт карданных валов" },
      { id: "vosstanovlenie_rychagov", name: "восстановление рычагов" },
      { id: "remont_podveski", name: "ремонт подвески" },
      { id: "shok_test_amortizatorov", name: "шок-тест амортизаторов" },
      { id: "zamena_amortizatorov", name: "замена амортизаторов" },
      { id: "zamena_silentblokov", name: "замена сайлентблоков" },
      { id: "remont_hodovoy", name: "ремонт ходовой" }
    ]
  },
  {
    id: "remont_dvigatelya",
    name: "Ремонт двигателя",
    children: [
      { id: "zamena_grm", name: "замена ГРМ" },
      { id: "zamena_dvigatelya", name: "замена двигателя" },
      { id: "remont_benz_dvigatelei", name: "ремонт двигателей бензиновых" },
      { id: "remont_dizel_dvigatelei", name: "ремонт двигателей дизельных" },
      { id: "kapitalny_remont_dvigatelya", name: "капитальный ремонт двигателя" },
      { id: "remont_gibridnykh_dvigatelei", name: "ремонт двигателей гибридных" },
      { id: "remont_turbin", name: "ремонт турбин" },
      { id: "remont_gbc", name: "ремонт ГБЦ" },
      { id: "zashita_kartera", name: "защита картера двигателя" },
      { id: "remont_okhlazhdeniya", name: "ремонт системы охлаждения" },
      { id: "zamena_remnya", name: "замена ремня" },
      { id: "zamena_masla", name: "замена масла" },
      { id: "vodorodnaya_ochistka", name: "водородная очистка двигателя" }
    ]
  },
  {
    id: "remont_kpp",
    name: "Ремонт КПП",
    children: [
      { id: "remont_mkpp", name: "ремонт МКПП" },
      { id: "remont_akpp", name: "ремонт АКПП" },
      { id: "remont_variatorov", name: "ремонт вариаторов" },
      { id: "remont_dsg", name: "ремонт DSG" },
      { id: "zamena_mkpp", name: "замена МКПП" },
      { id: "zamena_scепleniya", name: "замена сцепления" },
      { id: "remont_scепleniya", name: "ремонт сцепления" },
      { id: "remont_razdatki", name: "ремонт раздаточной коробки" },
      { id: "remont_reduktora", name: "ремонт редуктора" },
      { id: "zamena_akpp", name: "замена АКПП" },
      { id: "zamena_korobok", name: "замена коробок" },
      { id: "remont_kardannykh_valov_kpp", name: "ремонт карданных валов" },
      { id: "zamena_masla_akpp", name: "замена масла в АКПП" }
    ]
  },
  {
    id: "remont_rulevogo",
    name: "Ремонт рулевого управления",
    children: [
      { id: "zamena_rulevoi_tyagi", name: "замена рулевой тяги" },
      { id: "diagnostika_rulevoi", name: "диагностика рулевой" },
      { id: "remont_rulevoi_reiki", name: "ремонт рулевой рейки" },
      { id: "remont_gidrousiliteley", name: "ремонт гидроусилителей" }
    ]
  },
  {
    id: "tormoznaya_sistema",
    name: "Тормозная система",
    children: [
      { id: "remont_tormoznoy_sistemy", name: "ремонт тормозной системы" },
      { id: "protochka_diskov", name: "проточка тормозных дисков" },
      { id: "proverka_na_stende", name: "проверка на тормозном стенде" },
      { id: "zamena_kolodok", name: "замена тормозных колодок" },
      { id: "zamena_diskov", name: "замена тормозных дисков" },
      { id: "zamena_tormoznoy_zhidkosti", name: "замена тормозной жидкости" },
      { id: "remont_suportov", name: "ремонт суппортов" }
    ]
  },
  {
    id: "diagnostika_avtomobiley",
    name: "Диагностика автомобилей",
    children: [
      { id: "kompyuternaya_diagnostika", name: "компьютерная диагностика" },
      { id: "diagnostika_podveski", name: "диагностика подвески" },
      { id: "diagnostika_dvigatelya", name: "диагностика двигателя" },
      { id: "diagnostika_dizel_dvigatelei", name: "диагностика дизельных двигателей" },
      { id: "diagnostika_benz_dvigatelei", name: "диагностика бензиновых двигателей" },
      { id: "diagnostika_gibridnykh_dvigatelei", name: "диагностика гибридных двигателей" },
      { id: "diagnostika_akpp", name: "диагностика АКПП" },
      { id: "diagnostika_toplivnoy_sistemy", name: "диагностика топливной системы" },
      { id: "diagnostika_tnvd", name: "диагностика ТНВД" },
      { id: "diagnostika_turbin", name: "диагностика турбин" },
      { id: "diagnostika_elektroustroystva", name: "диагностика электрооборудования" },
      { id: "diagnostika_hodovoy", name: "диагностика ходовой" }
    ]
  },
  {
    id: "konditsioner_radiatory",
    name: "Кондиционер, радиаторы",
    children: [
      { id: "zapravka_konditsionerov", name: "заправка кондиционеров" },
      { id: "remont_konditsionerov", name: "ремонт кондиционеров" },
      { id: "argonaya_svarka", name: "аргонная сварка" },
      { id: "remont_radiatorov", name: "ремонт радиаторов" },
      { id: "zamena_radiatora", name: "замена радиатора" },
      { id: "zamena_radiatora_pechki", name: "замена радиатора печки" },
      { id: "promyvka_pechki", name: "промывка печки" }
    ]
  },
  {
    id: "zamena_masla",
    name: "Замена масла",
    children: [
      { id: "zamena_grm_masla", name: "замена ГРМ" },
      { id: "zamena_masla_dvigatelya", name: "замена масла в двигателе" },
      { id: "zamena_masla_akpp", name: "замена масла в АКПП" },
      { id: "zamena_masla_korobki", name: "замена масла в коробке" },
      { id: "ekspress_zamena_masla", name: "экспресс замена масла" },
      { id: "zamena_antifreza", name: "замена антифриза" },
      { id: "centr_zameny_masla", name: "центр замены масла" },
      { id: "zamena_tormoznoy_zhidkosti", name: "замена тормозной жидкости" }
    ]
  },
  {
    id: "shinomontazh",
    name: "Шиномонтаж",
    children: [
      { id: "shinomontazh_balansirovka", name: "шиномонтаж и балансировка" },
      { id: "varka_porezov_shin", name: "варка боковых порезов шин" },
      { id: "pravka_svarka_diskov", name: "правка, сварка дисков" },
      { id: "pokraska_diskov", name: "покраска дисков" },
      { id: "zapolnenie_shin_azotom", name: "заполнение шин азотом" },
      { id: "khranenie_shin", name: "хранение шин" },
      { id: "razval_skhodjdenie_shinomontazh", name: "развал схождение" },
      { id: "shiny_prodazha", name: "шины - продажа" }
    ]
  }
],
statuses: [
        {
          code: "new",
          name: "Новый",
          color: "linear-gradient(180deg, #fea530, #e48e1e)"
        },
        {
          code: "sto-prodazaza",
          name: "Необходим подбор и продажа запчастей",
          color: "#add8e6"
        },
        {
          code: "stoffnksajn12212",
          name: "Авто ожидает ремонта (ждет зч/очередь)",
          color: "rgb(255 239 191)"
        },
        {
          code: "avto-v-remonte-v-tsekhu",
          name: "Авто в ремонте, в цеху",
          color: "rgb(152 188 223)"
        },
        {
          code: "stowfifdk2j",
          name: "Ничего не нужно, не поможем (указываем причину)",
          color: "rgb(217 220 255)",
          text: ""
        },
        {
          code: "5asjkdhgfilu333",
          name: "5а. Собственная продажа магазина",
          color: "rgb(33, 184, 137)",
          text: ""
        },
        {
          code: "gotov-k-vydache",
          name: "Готово к выдаче авто",
          color: "#90ee90"
        },
        {
          code: "prokonsultirovan-perezvonit-pozzhe",
          name: "Проконсультирован, пнуть клиента позже",
          color: "#d3d3d3"
        },
        {
          code: "neobkhodimo-perezvonit-klientu-zapchasti-tseny-perechen-rabot-sto",
          name: "Необходимо перезвонить клиенту: запчасти, цены, перечень работ (СТО)",
          color: "#ffe4b5"
        },
        {
          code: "5-avto-vydan-klientu",
          name: "Авто выдан клиенту",
          color: "#add8e6"
        }
      ]
,
    tempSelectedServices: [],
      selectedServices: [],

      // Новые данные для модального окна "Новый заказ"
      newOrderTitle: "",
      newOrderDateInput: new Date(),
      newOrderPhone: "",
      newOrderCar: "",
      newOrderComment: "",
      newOrderName:"",




      expandedServices: {}, // Объект для хранения состояния раскрытия категорий
      activeStatus: "",
      showAllFilterButtons: false,
      page: 1,
      perPage: 100,
      apiEndpoint: ORDERS_API_BASE + "/sto_orders.php",
      // Новые поля для телефона и машины:
    newTaskPhone: "",
    newTaskCar: "",
      droppedOrder: null,
      // Переменные для редактирования даты/времени в модалках
      newTaskTimeInput: "08:00",
      editDateInput: "",
      editTaskTimeInput: "08:00",
      // Добавляем конфигурацию для flatPickr
      flatpickrConfig: {
        locale: Russian, // Русификация
        enableTime: true, // Включаем выбор времени
        dateFormat: "d.m.Y H:i", // Формат отображения даты и времени
        time_24hr: true  // 24-часовой формат
      }
    };
  },
  computed: {
    currentUser() {
      return this.$store && this.$store.state.user
        ? this.$store.state.user
        : { id: 1, label: "Я" };
    },
    displayLabel() {
      const d = this.currentDate;
      if (this.viewMode === "month") {
        return d.toLocaleString("ru", { month: "long", year: "numeric" });
      } else if (this.viewMode === "week") {
        const start = new Date(d);
        let dayOfWeek = start.getDay() || 7;
        if (dayOfWeek !== 1) {
          start.setDate(start.getDate() - (dayOfWeek - 1));
        }
        const end = new Date(start);
        end.setDate(start.getDate() + 6);
        const options = { day: "numeric", month: "short", year: "numeric" };
        return `${start.toLocaleDateString("ru", options)} – ${end.toLocaleDateString("ru", options)}`;
      } else {
        return d.toLocaleDateString("ru", { day: "numeric", month: "long", year: "numeric" });
      }
    },
    currentDayTasks() {
      const ymd = this.formatDateToYMD(this.currentDate);
      return this.tasks.filter(task => task.date === ymd);
    },
    visibleFilterStatuses() {
      return this.showAllFilterButtons ? this.filterStatuses : this.filterStatuses.slice(0, 6);
    },
    timeOptions() {
      const options = [];
      for (let h = 8; h < 19; h++) {
        for (let m = 0; m < 60; m += 30) {
          const hh = String(h).padStart(2, "0");
          const mm = String(m).padStart(2, "0");
          options.push(`${hh}:${mm}`);
        }
      }
      options.push("19:00");
      return options;
    }
  },
  methods: {
async fetchTasks() {
      try {
        const response = await axios.get("https://manager.1akb.by/getAllTasks");
        if (response.status === 200) {
          this.tasks = response.data;
        }
      } catch (error) {
        console.error("Ошибка получения задач:", error);
      }
    },
    parseFlatpickrDate(dateStr) {
    // Ожидается формат "d.m.Y H:i"
    const parts = dateStr.split(" ");
    if (parts.length < 2) return new Date(dateStr); // fallback
    const [d, m, y] = parts[0].split(".");
    const [h, i] = parts[1].split(":");
    return new Date(Number(y), Number(m) - 1, Number(d), Number(h), Number(i));
  },
extractImageUrl(text) {
    if (!text || typeof text !== 'string') return null;
    const regex = /(https?:\/\/[^\s]+?\.(?:jpeg|jpg|gif|png|webp|svg|bmp)(?:\?[^\s]*)?)/i;
    const match = text.match(regex);
    return match ? match[0] : null;
  },

  // Проверяет, есть ли вообще картинка
  hasImage(text) {
    return this.extractImageUrl(text) !== null;
  },

  async copyToClipboard(url, orderId) {
    if (!url) return;
    
    try {
      await navigator.clipboard.writeText(url);
      
      // Vue 2.7: используем $set, чтобы сделать новое свойство реактивным
      this.$set(this.copiedStates, orderId, true);

      // Возвращаем кнопку в исходное состояние через 2 секунды
      setTimeout(() => {
        this.$set(this.copiedStates, orderId, false);
      }, 2000);

    } catch (err) {
      console.error('Не удалось скопировать текст: ', err);
    }
  },

async saveNewTask() {
  if (!this.newTaskText.trim() || !this.newTaskTitle.trim()) return;
  
  let newTaskDate =
    typeof this.selectedDateInput === "string"
      ? this.parseFlatpickrDate(this.selectedDateInput)
      : this.selectedDateInput;
  
  const formattedDate = this.formatDateToYMD(newTaskDate);
  const start_hour = newTaskDate.getHours() + (newTaskDate.getMinutes() >= 30 ? 0.5 : 0);
  
  const newTask = {
    id: Date.now() + Math.random(),
    order_id: this.droppedOrder ? this.droppedOrder.id : null,
    order_info: this.droppedOrder ? this.droppedOrder : null,
    title: this.newTaskTitle.trim(),
    text: this.newTaskText.trim(),
    date: formattedDate,
    start_hour: start_hour,
    duration: 0.5,
    completed: false,
    user_id: this.currentUser.id,
    user_label: this.currentUser.label,
    created_at: new Date().toISOString(),
    user: this.currentUser,
    startHour: start_hour,
    // Передаём новые поля
    phone: this.newTaskPhone,
    car: this.newTaskCar
  };
  
  try {
    const response = await axios.post("https://manager.1akb.by/addTaskSto", newTask);
    if (response.status === 200) {
      this.tasks.push(newTask);
      this.closeAddModal();
    }
  } catch (error) {
    console.error("Ошибка при сохранении задачи:", error);
  }
},

   async saveEditedTask() {
  if (!this.editTaskText.trim() || !this.editTaskTitle.trim()) return;
  
  let editTaskDate =
    typeof this.editDateInput === "string"
      ? this.parseFlatpickrDate(this.editDateInput)
      : this.editDateInput;
  
  const formattedDate = this.formatDateToYMD(editTaskDate);
  const start_hour = editTaskDate.getHours() + (editTaskDate.getMinutes() >= 30 ? 0.5 : 0);

  const updatedTask = {
    id: this.editingTask.id,
    order_id: this.editingTask.order && this.editingTask.order.id ? this.editingTask.order.id : "",
    title: this.editTaskTitle.trim(),
    order_info: this.editTaskOrder || null, // Исправлено: убрано лишнее this.
    text: this.editTaskText.trim(),
    date: formattedDate,
    start_hour: start_hour,
    duration: this.editingTask.duration || 0.5,
    completed: this.editingTask.completed || false,
    user_id: this.editingTask.user ? this.editingTask.user.id : this.currentUser.id,
    user_label: this.editingTask.user ? this.editingTask.user.label : this.currentUser.label,
    user: this.editingTask.user || this.currentUser,
    startHour: start_hour
  };

  try {
    const response = await axios.post(`https://manager.1akb.by/updateTask/${updatedTask.id}`, updatedTask);
    if (response.status === 200) {
      Object.assign(this.editingTask, updatedTask);
      this.closeEditModal();
    }
  } catch (error) {
    console.error("Ошибка при обновлении задачи:", error);
  }
}
,

formatDates(dateStr) {
      // Разбиваем строку по пробелу, берем только дату
      const [datePart] = dateStr.split(' ');
      // Разбиваем дату на год, месяц, день
      const [year, month, day] = datePart.split('-');
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];
      // Преобразуем день и месяц в числа для удаления лишних нулей
      return `${parseInt(day, 10)} ${months[parseInt(month, 10) - 1]} ${year} г`;
    },

 getOrderField(task, field) {
  if (!task.order_info) {
    return '';
  }
  let orderInfo;
  if (typeof task.order_info === 'string') {
    try {
      orderInfo = JSON.parse(task.order_info);
    } catch (e) {
      console.error("Ошибка парсинга order_info:", e);
      return '';
    }
  } else {
    orderInfo = task.order_info;
  }
  return orderInfo && orderInfo[field] ? orderInfo[field] : '';
},
   async deleteTask(task) {
    if (!task.user_id || task.user_id !== this.currentUser.id) return;
    try {
      const response = await axios.delete(`https://manager.1akb.by/deleteTask/${task.id}`);
      if (response.status === 200) {
        this.tasks = this.tasks.filter(t => t.id !== task.id);
      }
    } catch (error) {
      console.error("Ошибка при удалении задачи:", error);
    }
  },
    async handleTaskDropped({ taskId, newDate, newStartTime }) {
      if (taskId.startsWith("order:")) {
        const orderId = taskId.slice(6);
        const orderIndex = this.orders.findIndex(o => String(o.id) === orderId);
        if (orderIndex !== -1) {
          const order = this.orders[orderIndex];
          this.selectedDate = newDate;
          this.selectedTime = newStartTime;
          let defaultDate = new Date(newDate);
          if (newStartTime !== undefined) {
            if (typeof newStartTime === "string") {
              const [hours, minutes] = newStartTime.split(":").map(Number);
              defaultDate.setHours(hours, minutes);
            } else if (typeof newStartTime === "number") {
              const hours = Math.floor(newStartTime);
              const minutes = (newStartTime % 1) ? 30 : 0;
              defaultDate.setHours(hours, minutes);
            }
          }
          this.selectedDateInput = defaultDate;
          this.newTaskText = "";
          this.newTaskTitle = "";
          
          // Присваиваем объект заказа и заполняем поля телефона и машины
          this.droppedOrder = order;
          this.newTaskPhone = order.phone || "";
          this.newTaskCar = order.car || "";

          // Проставляем выбранные работы из droppedOrder
          const rawServices = order.customFields && order.customFields.neobkhodimye_raboty_sto
            ? order.customFields.neobkhodimye_raboty_sto
            : '';

          const selectedNames = rawServices
            .split(',')
            .map(function(name) { return name.trim(); })
            .filter(function(name) { return !!name; });

          const selected = [];

          for (var i = 0; i < this.serviceList.length; i++) {
            var group = this.serviceList[i];
            for (var j = 0; j < group.children.length; j++) {
              var service = group.children[j];
              if (selectedNames.indexOf(service.name) !== -1) {
                selected.push({
                  id: service.id,
                  name: service.name
                });
              }
            }
          }

          this.selectedServices = selected;
          
          this.modalAddVisible = true;
        }
      }
 else {
        const newYMD = this.formatDateToYMD(newDate);
        const idx = this.tasks.findIndex(task => String(task.id) === String(taskId));
        if (idx !== -1) {
          const originalStart = this.tasks[idx].start_hour;
          // Если новое время не передано, оставляем исходное
          const updatedStartTime =
            newStartTime !== undefined && newStartTime !== null
              ? (typeof newStartTime === "string" ? this.parseTimeString(newStartTime) : newStartTime)
              : originalStart;
          this.tasks[idx].date = newYMD;
          this.tasks[idx].start_hour = updatedStartTime;
          this.tasks[idx].startHour = updatedStartTime;
          const updatedTask = {
            id: this.tasks[idx].id,
            order_id: this.tasks[idx].order && this.tasks[idx].order.id ? this.tasks[idx].order.id : "",
            title: this.tasks[idx].title || "",
            text: this.tasks[idx].text,
            date: newYMD,
            start_hour: updatedStartTime,
            duration: this.tasks[idx].duration || 0.5,
            completed: this.tasks[idx].completed || false,
            user_id: this.tasks[idx].user ? this.tasks[idx].user.id : this.currentUser.id,
            user_label: this.tasks[idx].user ? this.tasks[idx].user.label : this.currentUser.label,
            user: this.tasks[idx].user || this.currentUser,
            startHour: updatedStartTime
          };
          try {
            const response = await axios.post(`https://manager.1akb.by/updateTask/${updatedTask.id}`, updatedTask);
            if (response.status === 200) {
              this.$set(this.tasks, idx, updatedTask);
            }
          } catch (error) {
            console.error("Ошибка обновления задачи при перемещении:", error);
          }
        }
      }
    },
    switchView(mode) {
      this.viewMode = mode;
    },
    drillDownToDay(date) {
      this.currentDate = date;
      this.viewMode = "day";
    },
    selectDay(date) {
      this.currentDate = date;
    },
    addOrderItem() {
    this.newOrderItems.push({
      id: 541672, // или оставь null, если создаётся новый
      name: 'Выполнено работ на суммvу',
      quantity: 1,
      price: 0,
      offerId: '20907JD0Wx2fJjKFqxxMf0oinM2'
    });
  },
  removeOrderItem(index) {
    this.newOrderItems.splice(index, 1);
  },
    goPrev() {
      const d = new Date(this.currentDate);
      if (this.viewMode === "month") {
        d.setMonth(d.getMonth() - 1);
      } else if (this.viewMode === "week") {
        d.setDate(d.getDate() - 7);
      } else {
        d.setDate(d.getDate() - 1);
      }
      this.currentDate = d;
    },
    goNext() {
      const d = new Date(this.currentDate);
      if (this.viewMode === "month") {
        d.setMonth(d.getMonth() + 1);
      } else if (this.viewMode === "week") {
        d.setDate(d.getDate() + 7);
      } else {
        d.setDate(d.getDate() + 1);
      }
      this.currentDate = d;
    },
    formatTime(num) {
      if (typeof num !== "number") return "";
      const hour = Math.floor(num);
      const minutes = num % 1 ? "30" : "00";
      return hour.toString().padStart(2, "0") + ":" + minutes;
    },
 formatDateToYMD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  },
  formatDateToYMDcustom(date) {
  const year = date.getFullYear();
  const day = date.getDate();
  const months = [
    'января', 'февраля', 'марта', 'апреля',
    'мая', 'июня', 'июля', 'августа',
    'сентября', 'октября', 'ноября', 'декабря'
  ];
  const month = months[date.getMonth()];
  return `${day} ${month} ${year} г.`;
},


async makeCall(phone) {
  if (!phone || !this.$store.state.user.phone_extension) {
    console.log(this.$store.state.user.phone_extension);
    console.error("Не указан номер телефона или внутренний номер пользователя.");
    return;
  }

  const internalNumber = this.$store.state.user.phone_extension;

  // Удаляем все символы, кроме цифр
  let phoneNumber = phone.replace(/\D/g, '');

  // Преобразование номера, если он начинается с 8029 или других кодов
  if (phoneNumber.startsWith('80')) {
    phoneNumber = '375' + phoneNumber.slice(2);
  }

  if (!phoneNumber) {
    console.error("Некорректный номер телефона:", this.formData.phone);
    return;
  }

  // clientId (secret) — только для инициации звонков через makecallexternal
  const clientId = "e16bc4fc51d243ae80ab476c51b1e7c2";
  const url = `https://bot.vochi.by/api/makecallexternal?code=${encodeURIComponent(internalNumber)}&phone=${encodeURIComponent('+' + phoneNumber)}&clientId=${clientId}`;

  try {
    const response = await axios.get(url);

    if (response.data && response.data.success === false) {
      console.error("Ошибка при инициации звонка:", response.data.message || response.data);
    } else {
      console.log("Звонок успешно инициирован:", (response.data && response.data.message) || response.data);
    }
  } catch (error) {
    console.error("Ошибка при обращении к API Vochi:", error);
  }
},

    formatDate(ymd) {
      if (!ymd) return "";
      const [year, month, day] = ymd.split("-");
      return `${day}.${month}.${year.slice(-2)}`;
    },
    convertTimeNumberToTimeString(num) {
      if (typeof num !== "number") return "08:00";
      const hour = Math.floor(num);
      const minutes = num % 1 ? "30" : "00";
      return hour.toString().padStart(2, "0") + ":" + minutes;
    },
    parseTimeString(timeStr) {
      if (!timeStr) return 8;
      const [hour, minute] = timeStr.split(":").map(Number);
      return hour + (minute >= 30 ? 0.5 : 0);
    },
    openAddModal(date, time = null) {
      this.selectedDate = date;
      this.selectedTime = time;
      this.newTaskText = "";
      this.newTaskTitle = "";
      
      let defaultDateTime = new Date(date);
      if (time !== null) {
        if (typeof time === "string") {
          const [hours, minutes] = time.split(":").map(Number);
          defaultDateTime.setHours(hours, minutes);
        } else if (typeof time === "number") {
          const hours = Math.floor(time);
          const minutes = (time % 1) ? 30 : 0;
          defaultDateTime.setHours(hours, minutes);
        }
      }
      
      this.selectedDateInput = defaultDateTime;
      
      // Если задача создаётся перетаскиванием заказа, заполняем телефон и машину
      if (this.droppedOrder) {
        this.newTaskPhone = this.droppedOrder.phone || "";
        this.newTaskCar = this.droppedOrder.car || "";
      } else {
        this.newTaskPhone = "";
        this.newTaskCar = "";
      }
      
      this.modalAddVisible = true;
    },

editOrder(order) {
  this.modalNewOrderVisible = true;

  // Машина
  this.newOrderCar = order.customFields.sssylkaaaaasssyyylka ? order.customFields.sssylkaaaaasssyyylka : '';

  //this.services = order.customFields.neobkhodimye_raboty_sto ? order.customFields.neobkhodimye_raboty_sto : '';

  // Телефон и имя: сначала из customer, иначе из самого order
  if (order.customer && typeof order.customer === 'object') {
    this.newOrderPhone = order.customer.phone ? order.customer.phone : (order.phone ? order.phone : '');
    this.newOrderName = order.customer.firstName ? order.customer.firstName : '';
  } else {
    this.newOrderPhone = order.phone ? order.phone : '';
    this.newOrderName = '';
  }

  // Комментарий
  this.newOrderComment = order.managerComment ? order.managerComment : '';

  // Дата визита — если есть, иначе null
  if (order.customFields && typeof order.customFields === 'object') {
  const rawDate = order.customFields.planiruemaia_data_vizita;
  this.selectedDatePlan = rawDate ? new Date(rawDate.replace(' ', 'T')) : null;
} else {
  this.selectedDatePlan = null;
}


  // Работы
    // Получаем строку работ (без optional chaining)
const rawServices = order.customFields && order.customFields.neobkhodimye_raboty_sto
  ? order.customFields.neobkhodimye_raboty_sto
  : '';

// Преобразуем строку в массив названий, убираем пробелы
const selectedNames = rawServices
  .split(',')
  .map(function(name) { return name.trim(); })
  .filter(function(name) { return !!name; });

// Сопоставляем названия с объектами из serviceList
var selected = [];

for (var i = 0; i < this.serviceList.length; i++) {
  var group = this.serviceList[i];
  for (var j = 0; j < group.children.length; j++) {
    var service = group.children[j];
    if (selectedNames.indexOf(service.name) !== -1) {
      selected.push({
        id: service.id,
        name: service.name
      });
    }
  }
}

this.selectedServices = selected;


  // ID для редактирования
  this.editingOrderId = order.id;

  this.loadOrderItems(order.id);
},



async newOrder() {
  const isEditing = !!this.editingOrderId; // true, если это редактирование

  const orderPayload = {
    order: {
      id: isEditing ? this.editingOrderId : this.generateUniqueId(), // либо старый, либо новый
      orderType: { label: "Физическое лицо", value: "eshop-individual" },
      site: { label: "Центральный офис 1akb.by", value: "1akb-by" },
      managerId: {
        label: this.currentUser.label,
        value: this.currentUser.id,
      },
      orderMethod: {},
      contragent: {
        contragentType: { label: "Физическое лицо", value: "individual" },
      },
      products: [],
      comments: {
        customerComment: "",
        managerComment: "",
      },
      shipment: {
        shipmentDate: null,
        deliveryCost: null,
        deliveryAddress: "",
        deliveryDate: null,
        weight: null,
        dimensions: {
          length: null,
          width: null,
          height: null,
        },
      },
      deliveryTime: {
        from: null,
        to: null,
      },
      customTime: null,
      oneTimeDiscountAmount: null,
      oneTimeDiscountPercent: null,
      car: this.newOrderCar,
      managerComment: this.newOrderComment,
      customer: {
        phone: this.newOrderPhone,
        firstName: this.newOrderName
      },
      site: 'sto-prodaza',
      orderMethod: 'sto32',
      shipmentStore: 'sto',
      orderType: 'eshop-individual',
      planiruemaia_data_vizita: this.selectedDatePlan,
      services: this.selectedServices
    },
    edit: isEditing // отправим доп. флаг на бэк
  };

  try {
    const response = await axios.post(ORDERS_API_BASE + "/orderSto.php", orderPayload);
    if (response.status === 200 && response.data.success) {
      alert(isEditing ? "Заказ успешно обновлён!" : "Новый заказ успешно создан!");
      this.closeNewOrderModal();
      this.fetchOrders();
    } else {
      alert("Ошибка: " + response.data.message);
    }
  } catch (error) {
    console.error("Ошибка запроса:", error);
    alert("Произошла ошибка при сохранении заказа.");
  }
},

editingOrderId(newVal) {
  if (newVal) {
    const order = this.orders.find(o => o.id === newVal);
    if (order && order.items) {
      this.newOrderItems = order.items.map(item => ({
        id: item.id || null,
        name: (item.offer && item.offer.displayName) || (item.offer && item.offer.name) || '',
        quantity: item.quantity,
        price: (item.prices && item.prices.length > 0 && item.prices[0].price) || 0,
        offerId: (item.offer && item.offer.id) || null
      }));
    }
  } else {
    this.newOrderItems = [];
  }
}
,

openServiceModal() {
    // При открытии копируем текущий выбор в временный массив (если требуется)
    this.tempSelectedServices = [...this.selectedServices];
    this.serviceModalVisible = true;
  },
  closeServiceModal() {
    this.serviceModalVisible = false;
  },
 confirmServices() {
      this.selectedServices = [...this.tempSelectedServices];
      this.serviceModalVisible = false;
    },
    toggleService(serviceId) {
      // Переключаем состояние раскрытия для данной категории
      this.$set(this.expandedServices, serviceId, !this.expandedServices[serviceId]);
    },
    isExpanded(serviceId) {
      return !!this.expandedServices[serviceId];
    },
   closeAddModal() {
      this.modalAddVisible = false;
      this.selectedDateInput = new Date();
      this.newTaskText = "";
      this.selectedServices = "";
      this.newTaskTitle = "";
      this.droppedOrder = null;
    },
    // Метод для открытия модального окна нового заказа
    openNewOrderModal() {
      // Сброс значений формы нового заказа (если требуется)
      this.newOrderTitle = "";
      this.newOrderDateInput = new Date();
      this.newOrderPhone = "";
      this.newOrderCar = "";
      this.newOrderComment = "";
      this.modalNewOrderVisible = true;

    },
    closeNewOrderModal() {
      this.editingOrderId = null; // сброс редактируемого ID
      this.newOrderTitle = "";
      this.newOrderPhone = "";
      this.newOrderCar = "";
      this.newOrderComment = "";
      this.newOrderName = "";
      this.selectedDatePlan = new Date();
      this.selectedServices = [];
      this.newOrderItems = [];
      this.modalNewOrderVisible = false;
    },
    searchByPhone() {
      if (this.phoneFilter.trim().length >= 5) {
        this.fetchOrders();
      }
    },

    clearPhoneFilter() {
      this.phoneFilter = "";
      this.fetchOrders();
    },

    // Обработчик сохранения нового заказа
    async saveNewOrder() {
      const isEditing = !!this.editingOrderId;

      const orderItems = this.newOrderItems.map(item => ({
        quantity: item.quantity,
        initialPrice: item.price,
        offer: {
          name: item.name,
          displayName: item.name,
          id: item.offerId || undefined,
          xmlId: item.offerId || undefined,
          article: 'Noarticle2'
        },
        prices: [
          { price: item.price, quantity: item.quantity }
        ],
        purchasePrice: 0.01, // можно поправить если есть закупочная цена
        vatRate: 'none'
      }));

      const order = {
        order: {
          id: isEditing ? this.editingOrderId : undefined,
          car: this.newOrderCar.trim(),
          managerComment: this.newOrderComment.trim(),
          customer: {
            phone: this.newOrderPhone.trim(),
            firstName: this.newOrderName.trim()
          },
          site: 'sto-prodaza',
          orderMethod: 'sto32',
          shipmentStore: 'sto',
          orderType: 'eshop-individual',
          managerId: this.currentUser.id,
          contragent: { contragentType: "individual" },
          planiruemaia_data_vizita: this.selectedDatePlan,
          services: this.selectedServices,
          items: orderItems
        },
        edit: isEditing
      };

      try {
        const response = await axios.post(ORDERS_API_BASE + "/orderSto.php", order);
        if (response.status === 200 && response.data.success) {
          alert(isEditing ? "Заказ обновлён!" : "Новый заказ успешно создан!");
          this.closeNewOrderModal();
          this.fetchOrders();
        }
      } catch (error) {
        console.error("Ошибка при сохранении заказа:", error);
      }
    },

       // Метод для получения названия статуса по коду
    getStatusName(code) {
      const status = this.statuses.find(s => s.code === code);
      return status ? status.name : code;
    },
    // Пример метода для получения цвета (можно настроить под вашу логику)
    getStatusColor(code) {
      const status = this.statuses.find(s => s.code === code);
      return status ? status.color : '#fff';
    },
    updateCorpus(url) {
    this.newOrderCar = url; // Обновляем ссылку в форме
    this.closeCarSelector();          // Закрываем модальное окно
  },
   closeCarSelector() {
    this.isCarSelectorVisible = false; // Закрываем модальное окно
  },
  openCarSelector() {
    this.isCarSelectorVisible = true; // Открываем модальное окно
  },
  openEditModal(task) {
      this.editingTask = task;
      this.editTaskText = task.text;
      
      // Проверяем, что order_info существует
      if (task.order_info) {
        // Если order_info – строка, пытаемся его распарсить
        if (typeof task.order_info === "string") {
          try {
            this.editTaskOrder = JSON.parse(task.order_info);
          } catch (e) {
            console.error("Ошибка парсинга order_info:", e);
            this.editTaskOrder = {};
          }
        } else {
          // Если это уже объект, просто присваиваем его
          this.editTaskOrder = task.order_info;
        }
      } else {
        this.editTaskOrder = {};
      }

      this.editTaskTitle = task.title || "";
      
      // Преобразуем строку даты в объект Date
      let taskDate = new Date(task.date);
      // Если задано время выполнения, устанавливаем часы и минуты
      if (task.start_hour !== undefined) {
        const hours = Math.floor(task.start_hour);
        const minutes = (task.start_hour % 1) ? 30 : 0;
        taskDate.setHours(hours, minutes);
      }
      this.editDateInput = taskDate;
      this.modalEditVisible = true;
    },
    closeEditModal() {
      this.modalEditVisible = false;
      this.editingTask = null;
      this.editTaskText = "";
      this.editTaskTitle = "";
      this.editTaskOrder = "";
      this.editDateInput = "";
      this.editTaskTimeInput = "08:00";
    },
    logout() {
      

      // Очистка localStorage и Vuex состояния
      localStorage.removeItem('user');
      localStorage.removeItem('loginTime');
      this.$store.commit('setUser', null);

     

      // Переход на страницу входа
      this.$router.push('/login');
    },
    filterByStatus(statusValue) {
      this.activeStatus = statusValue;
      this.fetchOrders();
    },
    fetchOrders() {
      const filterParams = { sites: ["sto-prodaza"] };
      if (this.phoneFilter.trim() !== "") {
        filterParams.phone = this.phoneFilter.trim();
      }
      if (this.activeStatus) {
        filterParams.extendedStatus = [this.activeStatus];
      }
      axios
        .get(this.apiEndpoint, {
          params: {
            page: this.page,
            per_page: this.perPage,
            filter: filterParams
          }
        })
        .then(response => {
          if (response.data.orders) {
            this.orders = response.data.orders;
          } else {
            console.error("Ошибка получения заказов", response.data);
          }
        })
        .catch(error => {
          console.error("Ошибка запроса к API", error);
        });
    },
    loadOrderItems(orderId) {
    const order = this.orders.find(o => o.id === orderId);
    if (!order || !order.items || !order.items.length) {
      this.newOrderItems = [];
      return;
    }

    this.newOrderItems = order.items.map(item => {
      let name = '';
      if (item.offer && item.offer.displayName) {
        name = item.offer.displayName;
      } else if (item.offer && item.offer.name) {
        name = item.offer.name;
      }

      const price = (item.prices && item.prices.length > 0) ? item.prices[0].price : 0;

      return {
        id: item.id || null,
        name: name,
        quantity: item.quantity || 1,
        price: price,
        offerId: item.offer ? item.offer.externalId : null
      };
    });
  },
    onDragStartFromList(e, order) {
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", "order:" + String(order.id));
    },

    getStatusColor(status) {
      switch (status) {
        case "completed":
          return "#28a745";
        case "overdue":
          return "#dc3545";
        case "pending":
          return "#fd7e14";
        default:
          return "#6c757d";
      }
    },
    handleDaysBodyWheel(e) {
      e.preventDefault();
      if (e.deltaY > 0) {
        this.goNext();
      } else if (e.deltaY < 0) {
        this.goPrev();
      }
    }
  },

  mounted() {
    this.fetchOrders();
    this.fetchTasks();
  }
};
</script>





<style scoped>
/* Стили для инпутов и select */
.app-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 14px;
  margin-bottom: 5px;
  width: 100%;
  box-sizing: border-box;
  height: 44px;
}

/* Стили для меток */
label {
  margin-bottom: 4px;
    display: block;
    font-size: 12px;
    font-style: normal;
    line-height: 1.2;
    padding: 6px 10px 0 0;
    color: #636f7f;
    min-width: 158px;
    max-width: 158px;
    margin-right: 5px;
}



/* Стили для textarea */
.custom-modal__textarea {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  resize: vertical;
  min-height: 80px;
  font-size: 14px!important;
}

/* Стили для кнопок модального окна */
.custom-modal__btn {
  padding: 6px 12px;
  background-color: #007bff;
  border: none;
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
  margin-right: 0px;
}

.custom-modal__btn--cancel {
  background-color: #6c757d;
}

/* Стили для overlay модального окна */
.custom-modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Стили для модального окна */
.custom-modal {
  background: #fff;
  border-radius: 5px;
  width: 400px;
  max-width: 90%;
}

/* Общий контейнер приложения */
.calendar-app {
  display: flex;
  height: 100vh;
  width: 100%;
 
}

/* ====== Сайдбар (левая колонка) ====== */
.sidebar {
  width: 320px;
  background: #ffffff;
  border-right: 0px solid #dee2e6;
  padding: 20px;
  overflow-y: auto;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}

/* Webkit (Chrome, Safari, Edge) */
.sidebar::-webkit-scrollbar {
  width: 2px;
}

.sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
  border: 1px solid transparent;
}

/* Стили для вкладок */
.tabs {
  display: flex;
  margin-bottom: 20px;
}

.tabs button {
     flex: 1;
    padding: 6px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-weight: bold;
    font-size: 16px;
}

.tabs button.active {
  border-bottom: solid 1px;
}

/* --- Блок Калькуляции --- */
.calculation-block {
  margin-bottom: 20px;
}

/* Заголовок "Калькуляция (3) ... ₽" */
.calculation-header {
  display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 0px 5px;
}
.calculation-title {
    font-size: 14px;
    font-weight: 800;
    color: #333;
    margin-bottom: 5px;
    
}

.label_span {
  font-size: 10px;
    color: #8e8e8e;
    font-weight: 400;
    display: block;
    width: 100%;
}
.calculation-total {
  font-size: 14px;
  font-weight: normal;
  color: #333;
}

/* Список карточек задач (на сегодня) */
.calculation-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.calculation-item {
border-bottom: 1px solid #e6e6e6;
    border-radius: 0px;
    background: #fff;
    padding: 5px 5px;
    margin-bottom: 1px;
    position: relative;
    cursor: pointer;
    transition: transform 0.2s;
}
.calculation-item:hover {
  transform: translateY(-1px);
  background: #fcfcfc;
}

/* Верхняя часть карточки (авто + госномер и организация) */
.calculation-item-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1px;
}
.calculation-car-model {
  font-weight: 600;
  font-size: 14px;
  color: #444;
}
.calculation-plate {
  margin-left: 5px;
  color: #888;
  font-size: 13px;
}
.calculation-organization {
  font-size: 10px;
   color: #c4c4c4;
    font-weight: 400;
}

/* Основной блок: дата/время, телефон, комментарий */
.calculation-item-body {
  display: flex;
  flex-direction: column;
  gap: 0px;
  margin-bottom: 6px;
}
.calculation-date {
  font-size: 10px;
    color: #c4c4c4;
    font-weight: 400;
}
.calculation-phone a {
  font-size: 12px;
  color: #007bff;
  text-decoration: none;
}
.calculation-phone a:hover {
  text-decoration: underline;
}
.calculation-comment {
  font-size: 12px;
  color: #555;
  line-height: 1.3;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Стоимость (в правом нижнем углу карточки) */
.calculation-cost {
  font-weight: 700;
  font-size: 14px;
  color: #333;
  text-align: right;
}

/* Кнопка удаления (икс) */
.calculation-delete {
     position: absolute;
    top: 0px;
    right: -16px;
    font-size: 16px;
    color: #dc3545;
    cursor: pointer;
}

/* --- Блок заказов (фильтры + карточки) --- */
.orders-list {
  margin-top: 20px;
}
.orders-list h3 {
 font-weight: 800;
    font-size: 16px;
}
.filter-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}
.filter-buttons button {
  padding: 4px 8px;
    font-size: 12px;
    border: 0px solid #71717152;
    border-radius: 0px;
    background: #fff;
    cursor: pointer;
    transition: background 0.3s;
    line-height: 12px;
    font-weight: 600;
}
.filter-buttons button.active {
  position: relative;
}

.filter-buttons button.active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 15px solid white; /* размер и цвет треугольника */
  border-right: 15px solid transparent;
}

/* Сетка карточек заказов */
.orders-grid {
    display: flex;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    flex-wrap: wrap;
}
.order-card {
background: #ffffff;
    border-bottom: 0px solid #ced4da;
    border-radius: 0px;
    padding: 0px;
    cursor: grab;
    transition: box-shadow 0.2s;
    width: 100%;
}
.order-card:hover {
  box-shadow: 0 4px 6px rgba(0,0,0,0.15);
}
.order-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}
.order-phone {
      font-size: 12px;
    font-weight: 800;
    color: #212529;
}
.order-status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 12px;
  color: #fff;
  text-transform: uppercase;

}
.order-card-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.order-number {
  font-size: 10px;
  color: #6c757d;
}
.order-comment {
  font-size: 12px;
  color: #495057;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order-car {
  font-size: 12px;
  color: #6c757d;
}

.order-comment {

  display: none;
}

/* ====== Правая часть – календарь ====== */
.calendar-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.calendar-header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    padding: 10px;
    border-left: 1px solid #cfd8dc;
}
.header-btn {
  color: #000;
    border: none;
    padding: 8px 12px;
    margin: 0 4px;
    border-radius: 0px;
    cursor: pointer;
    transition: background 0.3s;
    width: 100px;
    background: #ffefbf;
}
.header-btn.active {
  background: #357ABD;
  color: #ffffff;
}
.nav-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
}
.header-current {
  font-size: 16px;
  font-weight: bold;
}

.custom-modal__info_sto{
  background: #f7f6f6;
    padding: 10px;
    font-size: 14px;
    line-height: 14px;
    margin-top: 20px;
    border-radius: 4px;
}

.custom-modal__info {
  width: 100%;
  margin-bottom: 10px;
  position: relative;
}


.form_date_block {
  display: flex;
    gap: 10px;
    margin: 0px;

}


.flatpickr-day.selected {
  background: #0052ca;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #fff;
    border-color: #0052ca;
}

/* Модальные окна */
.custom-modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.custom-modal {
  background: #fff;
  border-radius: 12px;
  width: 500px;
  max-width: 95%;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  overflow: hidden;
  transform: translateY(-20px);
  animation: slideDown 0.3s forwards;
}
@keyframes slideDown {
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.custom-modal__header {
  background: rgba(255, 220, 40, 0.15);
  padding: 10px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom-modal__content {
  padding: 20px;
  font-size: 16px;
  color: #333;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.custom-modal__textarea {
  width: 95%;
  height: 100px!important;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
  transition: border-color 0.2s;
}
.custom-modal__textarea:focus {
  border-color: #0052cc;
  outline: none;
}
.custom-modal__footer {
  background: #f7f7f7;
  padding: 15px 20px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
.custom-modal__btn {
  padding: 5px 20px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: #fff;
  transition: background 0.2s;
}
.calculation-title-header {
  font-weight: 800;
    font-size: 16px;
}
.custom-modal__btn:not(.custom-modal__btn--cancel) {
  background: #357ABD;
}
.custom-modal__btn:hover {
  transform: translateY(-2px);
}
.custom-modal__btn--cancel {
  background: #e0e0e0;
  color: #333;
}
.custom-modal__btn--cancel:hover {
  background: #d5d5d5;
}

.header-main{
    display: flex;
    empty-cells: hide;
    padding: 32px 0 24px;
    justify-content: space-between;
}




.header-main .hm-left {
    width: auto;
}

.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}





.hm-left h1 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
}

.header-main__title:not(:last-child) {
    margin-right: 16px;
}


.btn_ms {
    margin-right: 24px;
    background: linear-gradient(180deg, #fea530, #e48e1e) !important;
    color: #ffffff;
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    padding: 12px 24px;
}


.btn_md{
    font-size: 14px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
}


.btn-content {
    display: flex;
}

.btn-content_icon {
    margin-left: -8px;
}


.btn_ms.router-link-exact-active {
    margin-right: 15px;
    background: linear-gradient(180deg, #d4d4d4, #e6e6e6) !important;
    color: #000000;
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    padding: 12px 24px;
}


.order-card {
  position: relative;
  /* остальные стили карточки */
}

.tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  transform: translateY(5px);
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  white-space: normal;
  font-size: 12px;
  line-height: 1.3;
  z-index: 100;
  display: none;
  width: 250px; /* задайте нужную ширину */
}

::v-deep .order-card:hover .tooltip {
  display: block;
}



.calculation-block-zakaz {
       display: flex;
    gap: 20px;
    background: #f4f6f8;
}

.calculation-comment div {
  white-space: pre-line;
}


.block_zakaz{
    border-left: solid 1px rgb(255 255 255 / 95%);
    padding-left: 5px;
    position: relative;
}

.block_zakaz .label_span {
  font-size: 10px;
  color: #8e8e8e;
  font-weight: 400;
}


.block_zakaz div {
  font-weight: 700;
  font-size: 12px;
}


ul {
  list-style: none;
  padding-left: 0px;
}

.sto label {
  min-width: 100%;
  max-width: 100%;
}


.custom-modal__btn.sto {
   position: absolute;
    top: 80px;
    right: 20px;
    border: solid 0px #003e98;
    background: #357ABD;
    padding: 6px 15px;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.custom-modal__btn.sto svg {
      width: 28px;
     height: 28px;
}




.btn-content:before {
    content: "";
    height: 20px;
    margin-right: 8px;
    width: 20px;
}


.btn-content_icon:before {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100%;
    float: none !important;
    margin-left: 0 !important;
    top: 0 !important;
}



.btn-content_new:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23FFF' fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm1-9h2.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V13H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.btn_md .btn-content_icon:before, .btn_min-icon {
    height: 24px;
    width: 24px;
}

.btn-content_new {

    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;

    background: none;
    background-color: #005eeb;
    background-image: linear-gradient(180deg, #0068ff, #005bd5);
    border: none;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 32px;
    line-height: 20px;
    padding: 8px 20px;
    text-decoration: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 125px;
}

.btn-wrapper.btn-wrapper_group.new {
  display: flex;
}


.custom-modal.new_order .custom-modal__header {
    background: #357ABD;
    padding: 10px;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    color: #fff;
}


.custom-modal.new_order .custom-modal__btn.sto{
    position: absolute;
    top: 80px;
    right: 20px;
    border: solid 0px #003e98;
    background: #357ABD;
    padding: 6px 15px;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.calculation-block-zakaz-sto {
    display: flex;
    gap: 1px;
    margin-top: 0px;
    background: #f4f6f8;
    flex-wrap: wrap;
    height: auto;
    padding: 12px 0px;
}

.calculation-block-zakaz-sto .block_zakaz {
    border-left: solid 1px rgb(221 221 221);
    padding-left: 5px;
    width: 47%;
}


.block_zakaz_all {
    width: 100%;
    border-top: solid 1px #dddddd;
    margin-top: 5px;
     padding-left: 5px;
}


.block_zakaz_all  div {
    font-weight: 700;
    font-size: 12px;
}

.block_zakaz_all_select {
    width: 96.5%;
    padding: 5px;
    background: #4b4b4b12;
    margin-top: 5px;
    padding-top: 5px;
}


.block_zakaz_all_select .label_span {
  margin-bottom: 5px;
}

.contact_block {
      display: flex;
    justify-content: space-between;
    gap: 20px;
}


.custom-modal__btn.sto:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23FFF' fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm1-9h2.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V13H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11Z' clip-rule='evenodd'/%3E%3C/svg%3E");
      content: "";
    height: 20px;
    margin-right: 8px;
    width: 20px;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100%;
    float: none !important;
    margin-left: 0 !important;
    top: 0 !important;
    display: block;
}


.auto_podbor {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='630' height='630' contentScriptType='text/ecmascript' version='1.0'%3e%3cimage xlink:actuate='onLoad' xlink:href='data:image/png;base64,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' xlink:show='embed' xlink:type='simple' width='472.5' height='472.5' preserveAspectRatio='none' transform='scale(1.33333)'/%3e%3c/svg%3e");
    width: 54px;
height: 43px;

background-repeat: no-repeat;
background-color: #357abd;
background-position: center;
background-size: 85%;
border-radius: 3px !important;
display: block;

cursor: pointer;
transition: background-color 0.3s ease, transform 0.2s ease;
margin-right: 10px;
margin-bottom: 6px;

}

/* Состояние наведения */
.auto_podbor:hover {
  //background-color: #45a049; /* Более темный зеленый */
  transform: scale(1.05); /* Легкое увеличение */
}

/* Состояние клика */
.auto_podbor:active {
  //background-color: #388e3c; /* Еще темнее */
  transform: scale(0.95); /* Легкое уменьшение */
}
.modal {
  display: none; /* По умолчанию скрыто */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex; /* Центрирование содержимого */
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal.car-selector {
  display: block; /* Включается, когда окно открыто */
}

.modal.car-selector .modal-content {
  background: white;
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 600px;
    position: relative;
    max-height: 500px;
    overflow-y: auto;
}

.modal.car-selector .close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}


.call-button {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' style='shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;fill-rule:evenodd;clip-rule:evenodd'%3e%3cpath fill='%23fefffe' d='M277.5-.5h12c104.845 23.53 175.679 85.864 212.5 187a503.138 503.138 0 0 1 9.5 37v9c-5.458 10.198-13.458 12.698-24 7.5l-3.5-3.5C469.001 156.906 426.834 96.74 357.5 56c-26.136-14.045-53.802-23.712-83-29-9.874-10.441-8.874-19.608 3-27.5Z' style='opacity:.958'/%3e%3cpath fill='%23fefffe' d='M381.5 511.5h-28c-28.815-4.324-56.481-12.824-83-25.5C163.94 433.773 83.44 354.94 29 249.5c-14.802-29.566-24.635-60.566-29.5-93v-26c1.952-13.678 6.785-26.345 14.5-38A545.237 545.237 0 0 1 69.5 37c21.868-12.567 42.534-10.9 62 5a1855.233 1855.233 0 0 1 71.5 73.5c12.766 23.757 9.766 45.423-9 65L160.5 214c12.934 25.7 29.434 48.867 49.5 69.5 24.901 27.093 53.567 49.093 86 66a965.629 965.629 0 0 0 37.5-36.5c23.285-18.265 46.285-17.931 69 1l61.5 61.5c19.631 21.462 21.631 44.462 6 69a1765.816 1765.816 0 0 1-49.5 50.5c-11.803 8.539-24.803 14.039-39 16.5Zm-285-453c4.683.439 9.016 1.939 13 4.5l66.5 66.5c7.154 10.304 6.154 19.971-3 29a1101.106 1101.106 0 0 1-40 39c-4.129 5.699-5.462 12.032-4 19a226.895 226.895 0 0 0 25 47c28.999 39.668 63.833 73.168 104.5 100.5l30 16c9.672 3.236 18.338 1.57 26-5l41-41c8.557-6.189 16.89-5.855 25 1a3173.43 3173.43 0 0 1 66.5 67.5c4.667 7.333 4.667 14.667 0 22a1564.09 1564.09 0 0 1-46.5 47.5c-13.749 8.883-28.749 11.883-45 9a214.824 214.824 0 0 1-55-15C185.258 414.758 101.091 331.925 48 217.5c-10.483-23.434-16.65-47.934-18.5-73.5-.395-13.058 3.105-24.891 10.5-35.5L85.5 63c3.553-2.12 7.22-3.62 11-4.5Z' style='opacity:.959'/%3e%3cpath fill='%23fefffe' d='M277.5 91.5c66.203 12.096 111.203 49.596 135 112.5 4.165 10.819 5.998 21.985 5.5 33.5-4.462 8.479-11.296 11.313-20.5 8.5a25.55 25.55 0 0 1-6.5-5.5c-9.644-50.491-37.478-86.991-83.5-109.5a195.367 195.367 0 0 0-35-10c-11.123-8.204-11.79-17.204-2-27 2.427-.902 4.76-1.736 7-2.5Z' style='opacity:.955'/%3e%3c/svg%3e");
    width: 30px;
    height: 30px;
    left: 85px;
    background-repeat: no-repeat;
    background-color: #21b889;
    background-position: center;
    background-size: 70%;
    border-radius: 3px!important;
    display: block;
    right: -13px;
    top: 22px;
    cursor:pointer;
    margin-right: 5px;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

/* Состояние наведения */
.call-button:hover {
  //background-color: #45a049; /* Более темный зеленый */
  transform: scale(1.05); /* Легкое увеличение */
}

/* Состояние клика */
.call-button:active {
  //background-color: #388e3c; /* Еще темнее */
  transform: scale(0.95); /* Легкое уменьшение */
}

.edit-order-btn svg {
  width: 20px;
  height: 20px;
}

.edit-order-btn svg:hover path{
  fill: black;
}

.edit-order-btn {
    position: absolute;
    right: 9px;
    bottom: 18px;
    z-index: 9;
    cursor: pointer;
}

.phone-search-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 15px;
  position: relative;
  margin-bottom: 15px;
}

.phone-search-input {
  padding: 6px 30px 6px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 0px;
  outline: none;
  transition: border-color 0.2s ease;
  min-width: 200px;
}

.phone-search-input:focus {
  border-color: #357abd;
}

.clear-icon {
  position: absolute;
  right: 90px;
  background: none;
  border: none;
  font-size: 16px;
  color: #666;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.clear-icon:hover {
  color: #000;
}

.phone-search-button {
  padding: 6px 12px;
  font-size: 14px;
  background-color: #357abd;
  color: #fff;
  border: none;
  border-radius: 0px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.phone-search-button:hover {
  background-color: #2a5f95;
}


.custom-modal__btn.sto_product {
  position: absolute;
  right: 20px;
  top: 120px;
  font-size: 14px;
  display: flex;
align-items: center;
}


.custom-modal__btn.sto_product::before {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23FFF' fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm1-9h2.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V13H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11Z' clip-rule='evenodd'/%3E%3C/svg%3E");
  content: "";
  height: 20px;
  margin-right: 8px;
  width: 20px;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
  float: none !important;
  margin-left: 0 !important;
  top: 0 !important;
  display: block;
}


.compact-product-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fafafa;
  font-size: 13px;
}

.compact-input {
  padding: 4px 6px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 3px;
  flex-grow: 1;
}

.compact-input.name {
  min-width: 140px;
  flex-grow: 2;
}

.compact-input.small {
  width: 70px;
  text-align: center;
}

.sum {
  min-width: 80px;
  text-align: right;
  font-weight: 600;
  font-size: 13px;
}

.btn-remove {
  background: none;
  border: none;
  color: #c00;
  font-size: 16px;
  cursor: pointer;
  padding: 0 6px;
}

.custom-modal.sto {
  height: 55%;
  overflow-y: auto;
}

</style>
